import { BuildType } from '@/services/ApiService';
import { ApprenticeshipModel, ApprenticeshipsResponse, QueryApprenticeshipParams, UserApprenticeshipModel } from '@/types/Apprenticeship';

export const apprenticeshipApiEndpoints = (build: BuildType) => ({
    apprenticeships: build.query<ApprenticeshipsResponse, QueryApprenticeshipParams>({
        query: params => ({
            url: 'apprenticeships/query',
            method: 'POST',
            body: params,
        }),
        providesTags: ['Apprenticeships'],
    }),
    apprenticeshipDetails: build.query<ApprenticeshipModel, string>({
        query: id => `apprenticeships/${id}`,
    }),
    favoriteApprenticeship: build.mutation<void, ApprenticeshipModel>({
        query: apprenticeship => ({
            url: 'user-apprenticeships/favorite',
            method: 'POST',
            body: apprenticeship,
        }),
        invalidatesTags: ['Favorites', 'UserApprenticeships', 'Apprenticeships'],
    }),
    getFavoriteApprenticeships: build.query<UserApprenticeshipModel[], void>({
        query: () => 'user-apprenticeships/favorites',
        providesTags: ['UserApprenticeships'],
    }),
});
